<script>
  export let icon;
  export let size = undefined;
  export let tooltip = () => {};
  export let testid = undefined;
  export let fill = true;

  $: fontSize = size ? `${size}px` : undefined;
</script>

<span class='material-symbols-outlined icon' class:fill style:font-size={fontSize} use:tooltip data-cy={testid}>
  {icon}
</span>

<style lang='postcss'>
  .material-symbols-outlined.icon {
    font-variation-settings: 'FILL' 0;
    font-size: var(--Icon--size, var(--size--icon));
    color: var(--Icon--color);
    transition: inherit;

    &.fill {
      font-variation-settings: 'FILL' 1;
    }
    
    &:hover {
      color: var(--Icon--color--hover, var(--Icon--color));
    }

    &:active {
      color: var(--Icon--color--active, var(--Icon--color));
    }
  }
</style>
